export const TrackingPixelType = {
    MiQUniversal: {name: 'MiQ Universal', val: 1},
    MiQLandingPage: {name: 'MiQ Landing Page', val: 2},
    MiQConversion: {name: 'MiQ Conversion', val: 3},
}   